import { HashLink } from 'react-router-hash-link';


function AiChatbot() {
  return (
    <div className="bg-projects2 absolute top-0 left-0 min-h-screen w-full bg-gray-100 flex flex-col items-center justify-start px-4 sm:px-8 scroll-mt-[80px] -mt-[80px]">
      
      <div className="w-full max-w-4xl mx-auto pt-2">
        <HashLink
            smooth
            to="/#resume-prof-projects"
            className="inline-flex items-center text-sm font-semibold text-gray-800 border border-blue-200 px-3 py-2 rounded-lg hover:bg-blue-50 hover:border-blue-400 hover:shadow-sm transition-all"
        >
            <span className="mr-1">←</span> Go back to Home
        </HashLink>
      </div>

      <div className="max-w-4xl w-full bg-white rounded-xl shadow-lg p-6 sm:p-10 space-y-6">

        <h1 className="text-4xl font-bold title-color mb-2">
          ERD Script Compiler (Pilot)
        </h1>

        <p className="text-md text-gray-500 italic">
          Client: Top-tier global bank | Duration: Jan 2026 – Present | Internal Platform Engineering Initiative
        </p>

        <p className="text-base text-gray-700 mb-6">
          Designed and implemented a scalable Python-based compiler system for generating
          enterprise-grade Entity Relationship Diagrams (ERDs) from a custom
          domain-specific language (<code>.erd</code>). The platform decouples
          architectural intent from rendering logic, enabling ERD generation through
          multiple input modalities while maintaining a single, deterministic compilation core.
        </p>

        <ul className="list-disc list-inside space-y-3 text-base text-gray-700 mb-8">
          <li>
            Built a <strong>custom DSL interpreter</strong> using <strong>Lark</strong> to
            parse <code>.erd</code> scripts into a validated,
            <strong> AST-driven intermediate representation</strong> capturing ERD semantics.
          </li>

          <li>
            Implemented a <strong>layout-aware compilation engine</strong> capable of
            resolving entity positioning via a <strong>matrix-based coordinate model</strong>,
            with automatic path computation for joins, unions, and relational dependencies.
          </li>

          <li>
            Developed a <strong>rendering pipeline using openpyxl</strong> to materialize
            ERDs into Excel with consistent styling, merged-cell management,
            connector routing, and enterprise-ready visual standards.
          </li>

          <li>
            Architected the solution around a <strong>single compiler core</strong> with
            multiple interchangeable <strong>input “heads”</strong>, each responsible for
            generating DSL while delegating execution to the same compilation engine.
          </li>

          <li>
            Built an <strong>Excel-driven API head</strong> that reads structured spreadsheet
            inputs, generates equivalent DSL definitions, and invokes the compiler to
            produce ERDs. The workflow is packaged as a <strong>macro-enabled (.xlsm)
            workbook</strong> with a <strong>VBA-triggered execution layer</strong>, allowing
            users to generate ERDs directly from Excel via a button-driven interface while
            simultaneously <strong>persisting the generated DSL script</strong> for audit,
            reuse, and downstream automation.
          </li>

          <li>
            Provided a <strong>script-based execution head</strong> for direct compilation
            of <code>.erd</code> files, supporting power users, automation, and CI-friendly
            workflows.
          </li>

          <li>
            Designed the DSL explicitly for <strong>machine-writability</strong>, enabling
            future integration with <strong>LLMs</strong> to generate ERD intent
            programmatically while preserving deterministic compilation guarantees.
          </li>

          <li>
            Packaged the compiler and its auxiliary APIs as
            <strong> standalone executables using PyInstaller</strong>, eliminating runtime
            Python dependencies and enabling enterprise-friendly distribution.
          </li>

        </ul>

        <p className="text-sm text-gray-600">
          <strong>Status:</strong> Core compiler and execution heads complete, now integrated
          into an agentic AI platform enabling <strong>natural language-driven ERD generation</strong>.
          Users can describe data models conversationally, with agents handling feasibility analysis,
          schema exploration, and automated diagram creation. Internal evaluations demonstrate
          significant reductions in manual ERD creation time and structural inconsistencies.
          <br/>
          <a
            href="/aegis-aidp"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            Explore the agent platform
          </a>
        </p>

      </div>
    </div>
  );
}
  
  export default AiChatbot;  